

/*--------------------
* Service Section
----------------------*/
function Service(props) {
    return (
        <>
            <div className="lg:col-span-6">
                <div className={props.id.main + " feature-box-01"}>
                    <div className="icon"><i className={props.id.icon}></i></div>
                    <div className="feature-content">
                        <h5>{props.title}</h5>
                        <p>{props.description}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

/*--------------------
* Service List Section
----------------------*/
export default function ServiceList() {
    const service_list = [
        {id:{main:'bg-1', icon:'fab fa-react'}, title:'Web Development', description:'React is a JavaScript library for building user interfaces. It is used to create single-page applications, mobile apps, and server-rendered applications.'},
        {id:{main:'bg-2', icon:'fas fa-mobile'}, title:'App Development', description:'React Native is an open-source mobile application framework used to develop apps for Android, Apple, and Windows platforms; and for the web.'},
    ]
    return (
        <>
           <section data-scroll-data="1" id="services" className="section services-section bg-gray" style={{ "backgroundImage": "url(img/effect/bg-effect-1.png)", "backgroundRepeat": "no-repeat", "backgroundSize": "cover"}}>
                <div className="container">
                    <div className="grid section-heading">
                        <div className="lg:col-span-6 text-center mx-auto">
                            <h3><span>My Services</span></h3>
                        </div>
                    </div>
                    <div className="grid lg:grid-cols-12 md:grid-cols-2 gap-5 grid-cols-1 items-center">
                        {
                            service_list.map((val, i)=>{
                                return <Service key={i} id={val.id} title={val.title} description={val.description} />
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    );
}
